<template>
 
  <v-app>
  
<left v-if="isShow"></left>

  <!-- Sizes your content based upon application components -->
  <v-main>

    <!-- Provides the application the proper gutter -->
    <v-container >
      <!-- If using vue-router -->
      <router-view>

      </router-view>
      
    </v-container>

    
  </v-main>

  <v-footer app v-if="false">
    <!-- -->
  </v-footer>
 
 
 
</v-app>


 
</template>

<script>
 
import left from './components/left'
export default {
  name: 'App',
  data() {
    return {
      isShow: true
    }
  },
  components: {
   left
  },
 
  mounted() {
document.write(unescape("%3Cspan id='cnzz_stat_icon_1280480252'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1280480252' type='text/javascript'%3E%3C/script%3E"));
  },
  watch: {
    $route: {
          immediate: true, 
          handler(to,from) {
            // if(to.path == '/login' || to.path == '/home' || to.path == '/' || to.path == '/help') {
           if(to.path == '/login' || to.path == '/home' || to.path == '/' || to.path == '/help') {
              this.isShow = false
            }else {
              this.isShow = true
            }
          }
    }
  }
}


 
</script>

<style>
#app {
 
}
#cnzz_stat_icon_1280480252{ display:none;}
</style>
